import FileProviderViewState from '../store/schema/FileProviderViewState';
import { action } from 'satcheljs';
import { AddableFileProviderInfo } from 'owa-add-fileprovider';
import { FileProviderType } from '../utils/constants';

const addFileProvider = action(
    'ADD_FILE_PROVIDER',
    (
        providerType: FileProviderType,
        getAddableFileProviderInfoCustom?: (
            providerType: FileProviderType
        ) => AddableFileProviderInfo,
        updateProvider?: boolean
    ) => ({
        providerType: providerType as FileProviderType,
        getAddableFileProviderInfoCustom: getAddableFileProviderInfoCustom,
        updateProvider: updateProvider,
    })
);

const loadProviders = action(
    'LOAD_PROVIDERS',
    (
        onLoaded?: (providers: FileProviderViewState[]) => void,
        onError?: (error: Error) => void
    ) => ({
        onLoaded: onLoaded,
        onError: onError,
    })
);

const removeAndAddFileProvider = action(
    'REMOVE_AND_ADD_FILE_PROVIDER',
    (providerType: FileProviderType) => ({
        providerType: providerType as FileProviderType,
    })
);

const removeFileProvider = action('REMOVE_FILE_PROVIDER', (providerType: FileProviderType) => ({
    providerType: providerType as FileProviderType,
}));

export { removeFileProvider, removeAndAddFileProvider, loadProviders, addFileProvider };
export {
    default as AttachmentDataProviderType,
} from 'owa-service/lib/contract/AttachmentDataProviderType';
